var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 91.1 91.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6,0C20.4,0,0,20.4,0,45.6c0,25.2,20.4,45.6,45.6,45.6c25.2,0,45.6-20.4,45.6-45.6C91.1,20.4,70.7,0,45.6,0z M70.9,34.8     c-10.5,10.6-18.2,19.2-29,30c-2.2,2.2-5.7,2.4-8.1,0.3l-13-11c-0.1-0.1-0.2-0.2-0.3-0.2c-2.5-2.2-2.7-6-0.4-8.5     c2.2-2.5,6-2.7,8.5-0.4l8.7,7.4c8.6-8.8,15.8-16.6,25.2-26c1.1-1.1,2.6-1.8,4.1-1.8c1.7,0,3.3,0.6,4.5,1.8     C73.3,28.7,73.2,32.5,70.9,34.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleIcon);
export default __webpack_public_path__ + "static/media/check-circle-icon.398068585652e737d3dd1714fc134d9b.svg";
export { ForwardRef as ReactComponent };